<template>
  <div class="container">
   <Resultados :frsm="frsm" @show='show' v-if='frsm'></Resultados>
  </div>
</template>
<script>
import Resultados from './Resultados.vue'
import apiServices from '../../services/yungol-services'
import {mapState} from 'vuex'

export default {
  data(){
    return {
      frsm: null,
      showPage: false
    }
  },
  computed:{
    ...mapState(["idtoken"]),
  },
  methods:{
    async getData(){
      try {
        if(this.$route.params.id && this.$route.params.filter){
          let allFilters = atob(atob(this.$route.params.filter))
          allFilters = JSON.parse(allFilters)
          let result = null
          let data = {}

          result = await apiServices.get(`/informefrspublic/${this.$route.params.id}`);

          data = {
            nombre: result.data.nombre,
            id: result.data._id,
            status: result.data.status,
            responses: result.data.agrupadoras,
            dataAdmin: result.data.data,
            created: result.data.created,
            newFilter: { allFilters }
          };

          if (allFilters) {
            const filter = allFilters.board;
            if (filter){
              let dataFilter = await apiServices.post(`/filtroinformefrspublic`,{
                filtro: filter,
                idfrs: this.$route.params.id
              })
              data.newFilter = { ...dataFilter.data, allFilters };
            }
          }
          this.frsm = data
        }
      }catch (e){
        await this.$store.dispatch("notify", {
          message: `Error al cargar el tablero compartido`,
          type: "is-danger",
        });
      }
    },
    show(){
      this.showPage = true;
    }
  },
  created() {
    if (this.idtoken || this.$route.params.id){
      this.getData();
    }
  },
  watch:{
    idtoken(){
      if (this.idtoken && this.$route.params.id){
        this.getData();
      }
    }
  },
  components:{
    Resultados
  },
  errorCaptured(err, vm, info) {
    console.log({err, vm, info})
    this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frpm/ResultadoCompartido.vue